import FontWeights from '../../tokens/fontWeights';
import FontStyles from '../../tokens/fontStyles';
import fonts from '../../tokens/fonts';
const BUCKET_URL = 'https://storage.googleapis.com/hummingbirdtech-production-web-static-assets/fonts/';
const HELVETICA_NEUE_FOLDER = `${BUCKET_URL}/HelveticaNeue-stging`;
const NOTO_SANS_KR_FOLDER = `${BUCKET_URL}/Noto_Sans_KR`;
const ROBOTO_FOLDER = `${BUCKET_URL}/Roboto`;
const fontStyles = {
    '@font-face': [
        {
            fontFamily: fonts.notoSansKR,
            src: `url('${NOTO_SANS_KR_FOLDER}/NotoSansKR-Black.otf') format('otf')`,
            fontWeight: FontWeights.Heavy,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.notoSansKR,
            src: `url('${NOTO_SANS_KR_FOLDER}/NotoSansKR-Bold.otf') format('otf')`,
            fontWeight: FontWeights.Bold,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.notoSansKR,
            src: `url('${NOTO_SANS_KR_FOLDER}/NotoSansKR-Light.otf') format('otf')`,
            fontWeight: FontWeights.Light,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.notoSansKR,
            src: `url('${NOTO_SANS_KR_FOLDER}/NotoSansKR-Medium.otf') format('otf')`,
            fontWeight: FontWeights.Medium,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.notoSansKR,
            src: `url('${NOTO_SANS_KR_FOLDER}/NotoSansKR-Regular.otf') format('otf')`,
            fontWeight: FontWeights.Regular,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.notoSansKR,
            src: `url('${NOTO_SANS_KR_FOLDER}/NotoSansKR-Thin.otf') format('otf')`,
            fontWeight: FontWeights.Thin,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.helveticaNeue,
            src: `url('${HELVETICA_NEUE_FOLDER}/HelveticaNeue.otf') format('otf')`,
            fontWeight: FontWeights.Regular,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.helveticaNeue,
            src: `url('${HELVETICA_NEUE_FOLDER}/HelveticaNeue-Medium.otf') format('otf')`,
            fontWeight: FontWeights.Medium,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.helveticaNeue,
            src: `url('${HELVETICA_NEUE_FOLDER}/HelveticaNeue-Bold.otf') format('otf')`,
            fontWeight: FontWeights.Bold,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.roboto,
            src: `url('${ROBOTO_FOLDER}/Roboto-Regular.woff2') format('woff2')`,
            fontWeight: FontWeights.Regular,
            fontStyle: FontStyles.Normal,
        },
        {
            fontFamily: fonts.roboto,
            src: `url('${ROBOTO_FOLDER}/Roboto-Italic.woff2') format('woff2')`,
            fontWeight: FontWeights.Regular,
            fontStyle: FontStyles.Italic,
        },
    ],
};
export default fontStyles;
//# sourceMappingURL=fontStyles.js.map